import './ImportantButton.css';

const ImportantButton = ({buttonText, onClick}) => {
    return(
        <div className="text-center">
            <button className="important-button" onClick={onClick}>
                {buttonText}
            </button>
        </div>
    )
}

export { ImportantButton }